export function getDifferenceInPercent(currentValue, prevValue) {
  if (currentValue === prevValue) return 0;
  return (currentValue / prevValue) * 100 - 100;
}
